// extracted by mini-css-extract-plugin
export default {"wrap":"vH-z","subtitle":"wH-z","contentWrap":"xH-z","imgWrap":"yH-z","heading":"zH-z","copy":"AH-z"};